import { Bell, BellOff } from "lucide-react";
import { Link } from "react-router-dom";
import {
  useRoundCommunitySubscription,
  type RoundCommunity,
} from "@/lib/rounds";

export function CommunityRail({
  citySlug,
  communities,
  activeSlug,
}: {
  citySlug: string;
  communities: RoundCommunity[];
  activeSlug?: string;
}) {
  const subscription = useRoundCommunitySubscription(citySlug);

  return (
    <aside className="pb-rounds-community-rail" aria-label="Rounds communities">
      <div className="pb-rounds-community-rail__heading">
        <strong>Communities</strong>
        <Link to="/board/rounds/guidelines">Guidelines</Link>
      </div>
      <div className="pb-rounds-community-list">
        <Link
          to="/board/rounds"
          className="pb-rounds-community-all"
          aria-current={!activeSlug ? "page" : undefined}
        >
          <span>All Rounds</span>
          <small>{communities.reduce((sum, item) => sum + item.threadCount, 0)}</small>
        </Link>
        {communities.map((community) => {
          const busy =
            subscription.isPending && subscription.variables?.slug === community.slug;
          return (
            <div
              key={community.id}
              className="pb-rounds-community-item"
              data-active={community.slug === activeSlug || undefined}
            >
              <Link
                to={`/board/rounds/c/${encodeURIComponent(community.slug)}`}
                aria-current={community.slug === activeSlug ? "page" : undefined}
              >
                <span>{community.name}</span>
                <small>{community.threadCount}</small>
              </Link>
              <button
                type="button"
                disabled={busy}
                aria-pressed={community.subscribed}
                aria-label={`${community.subscribed ? "Unsubscribe from" : "Subscribe to"} ${community.name}`}
                title={`${community.subscribed ? "Unsubscribe from" : "Subscribe to"} ${community.name}`}
                onClick={() =>
                  subscription.mutate({
                    slug: community.slug,
                    subscribed: !community.subscribed,
                  })
                }
              >
                {community.subscribed ? (
                  <Bell size={13} aria-hidden="true" />
                ) : (
                  <BellOff size={13} aria-hidden="true" />
                )}
              </button>
            </div>
          );
        })}
      </div>
      {subscription.isError ? (
        <p className="pb-rounds-rail-error" role="alert">
          Subscription could not be updated.
        </p>
      ) : null}
    </aside>
  );
}
